import { gql } from '@apollo/client';

export const ON_DASHBOARD_MEASUREMENT = gql`
  subscription OnDashboardMeasurement($input: SubscribeForOnMeasurementInput!) {
    onDashboardMeasurement(input: $input) {
      data {
        ... on MeasurementSubscriptionError {
          unixTimestamp
          errorCode
          description
        }
        ... on MeasurementSubscriptionResponse {
          unixTimestamp
          scalarMeasurements {
            type
            value
          }
          vectorMeasurements {
            type
            index
            value
          }
        }
      }
    }
  }
`;

export const ON_DETAILS_MEASUREMENT = gql`
  subscription OnDetailsMeasurement($input: SubscribeForOnMeasurementInput!) {
    onDetailsMeasurement(input: $input) {
      data {
        ... on MeasurementSubscriptionError {
          unixTimestamp
          errorCode
          description
        }
        ... on MeasurementSubscriptionResponse {
          unixTimestamp
          scalarMeasurements {
            type
            value
          }
          vectorMeasurements {
            type
            index
            value
          }
        }
      }
    }
  }
`;

export const ON_LIVE_MEASUREMENT = gql`
  subscription OnLiveMeasurement($input: SubscribeForOnMeasurementInput!) {
    onLiveMeasurement(input: $input) {
      data {
        ... on MeasurementSubscriptionError {
          unixTimestamp
          errorCode
          description
        }
        ... on MeasurementSubscriptionResponse {
          unixTimestamp
          scalarMeasurements {
            type
            value
          }
          vectorMeasurements {
            type
            index
            value
          }
        }
      }
    }
  }
`;
